<div *ngIf="visible" class="acquisition-backdrop">
  <div class="acquisition-modal">

    <div class="acquisition-header">
      <div class="acquisition-icon-wrap">
        <i class="pi pi-star-fill"></i>
      </div>
      <h2 class="acquisition-title">¡Bienvenido/a a Globot!</h2>
      <p class="acquisition-subtitle">
        Antes de comenzar, cuéntanos: <strong>¿cómo nos conociste?</strong>
      </p>
    </div>

    <div class="acquisition-options">
      <div
        *ngFor="let option of options"
        class="acquisition-option"
        [class.acquisition-option--active]="selectedSource === option.value"
        (click)="selectOption(option.value)"
        (keydown.enter)="selectOption(option.value)"
        (keydown.space)="selectOption(option.value)"
        role="button"
        tabindex="0"
      >
        <div class="acquisition-option-icon">
          <i class="pi {{ option.icon }}"></i>
        </div>
        <div class="acquisition-option-text">
          <span class="acquisition-option-label">{{ option.label }}</span>
          <span class="acquisition-option-desc">{{ option.description }}</span>
        </div>
      </div>
    </div>

    <div class="acquisition-other" *ngIf="selectedSource === 'other'">
      <input
        type="text"
        class="acquisition-other-input"
        placeholder="Cuéntanos cómo nos conociste..."
        [(ngModel)]="otherText"
        maxlength="150"
      />
    </div>

    <div class="acquisition-footer">
      <button
        class="acquisition-btn-save"
        type="button"
        (click)="save()"
        [disabled]="!canSave || saving"
      >
        <i class="pi pi-send" *ngIf="!saving"></i>
        <i class="pi pi-spin pi-spinner" *ngIf="saving"></i>
        Guardar
      </button>
    </div>

  </div>
</div>
